export interface GetExternalCollaborationPasswordRequest {
  externalId: string
}

export function GetExternalCollaborationPasswordRequestToJSON(
  value: GetExternalCollaborationPasswordRequest
): any {
  return {
    external_id: value.externalId !== '' ? value.externalId : undefined
  }
}
